var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpenseModule(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 73,
    viewBox: "0 0 90 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5615 18.5972H36.1252",
    stroke: "#021472",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6956 22.9966H72.2682C64.4335 22.9966 58.082 28.9054 58.082 36.1948C58.082 43.4842 64.4335 49.3931 72.2682 49.3931H83.6956C84.0618 49.3931 84.2444 49.3931 84.399 49.3839C86.767 49.2391 88.6529 47.4846 88.8084 45.2814C88.8185 45.1375 88.8185 44.9673 88.8185 44.6272V27.7625C88.8185 27.4224 88.8185 27.252 88.8084 27.1083C88.6529 24.9052 86.767 23.1504 84.399 23.006C84.2444 22.9966 84.0618 22.9966 83.6956 22.9966Z",
    stroke: "#021472",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2738 22.9971C83.9326 14.7601 82.8318 9.70975 79.2831 6.15423C74.1391 0.999999 65.8591 1 49.3001 1H36.1273C19.5681 1 11.2886 0.999999 6.14427 6.15423C1 11.3085 1 19.6041 1 36.1954C1 52.7865 1 61.0824 6.14427 66.2364C11.2886 71.3907 19.5681 71.3907 36.1273 71.3907H49.3001C65.8591 71.3907 74.1391 71.3907 79.2831 66.2364C82.8318 62.6812 83.9326 57.6307 84.2738 49.3936",
    stroke: "#021472",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2148 36.1947H71.255",
    stroke: "#021472",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenseModule);
export default __webpack_public_path__ + "static/media/expenseModule.db99d6cb5c3dec1cefd23e6b9d831b20.svg";
export { ForwardRef as ReactComponent };